import { render, staticRenderFns } from "./model_edit.vue?vue&type=template&id=59f8df44&scoped=true"
import script from "./model_edit.vue?vue&type=script&lang=ts"
export * from "./model_edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f8df44",
  null
  
)

export default component.exports